import bem from 'utils/bem';

export const block = bem('quality-reduction-alert-modal');
